import React from 'react';

export const Eula = (
	<div>
		<p>
			Lue alla olevat käyttöehdot huolellisesti. Hyväksymällä ehdot saat käyttöoikeuden E-Spiral-lomakkeeseen (Palvelu). Käyttöehdoissa Palvelulla 
			tarkoitetaan kokonaisuutta, joka koostuu E-Spiral-lomakkeen eri versioista.
		</p>

		<p>
			Kuntoutussäätiö (Palvelun tarjoaja) tarjoaa Palvelun käyttöösi. Palvelu on tarkoitettu toimintakyvyn ja siinä koettujen muutostarpeiden arvioinnin 
			tueksi. Saadut tulokset perustuvat itsearviointiin ja ovat suuntaa antavia.
		</p>

		<h2 className='mt-4'>Vastaustietojen tallentuminen ja käsittely</h2>

		<p>
			Vastaustiedoilla tarkoitetaan vastaamisessa tietoverkon välityksellä tallentuvia tietoja. Lomakkeelle vastataan nimettömästi. Lomakkeen lopussa 
			kerättävien taustatietojen antaminen on vapaaehtoista. Vastaustietoja käsitellään luottamuksellisesti. Vastaustietoja käytetään Palvelun ja 
			Spiral-menetelmän jatkokehittämisessä sekä tähän liittyvässä tutkimustoiminnassa. Vastaustietoja säilytetään toistaiseksi. 
		</p>

		<p>
			Tarkemmat tiedot vastausten käsittelystä löydät <a href='https://hankkeet.kuntoutussaatio.fi/spiral/tietosuojaseloste-e-komo-ja-e-spiral' target="_blank" rel='noopener noreferrer'>tietosuojaselosteesta.</a>
		</p>

		<p>
			Lomakkeen täyttämisen yhteydessä käyttäjä saa henkilökohtaisen koodin sekä linkin, joiden avulla käyttäjän on mahdollista nähdä omat vastaustietonsa 
			kolmen (3) kuukauden ajan lomakkeen täyttämisestä. Vastaustiedot ovat vain käyttäjän ja palvelun tarjoajan nähtävissä, ellei käyttäjä itse 
			toimita tietojaan eteenpäin. Käyttäjä on vastuussa kaikista henkilökohtaisista koodeista ja linkeistä, jotka hän saa palvelua käyttäessään haltuunsa. 
			Käyttäjän on säilytettävä henkilökohtaisia koodeja ja linkkejä huolellisesti, eikä niiden luovuttaminen ulkopuoliselle ole suositeltavaa. 
			Käyttäjä on vastuussa kaikista henkilökohtaisilla koodeilla ja linkeillä tehdyistä toimenpiteistä Palvelussa.
		</p>

		<p>Palvelun tarjoaja ei pysty identifioimaan yksittäistä koodia käyttäjään.</p>

		<h2 className='mt-4'>Palvelun käyttäminen</h2>

		<p>
			Käyttäjä hankkii itse Palvelun käyttämiseen tarvittavat päätelaitteet ja Internet-yhteyden. Palvelun käyttäminen kaupallisiin tarkoituksiin on 
			kiellettyä. Palvelun tarjoaja ei ole vastuussa Palvelun käytöstä aiheutuvista puhelu- tai muista maksuista. Palvelun tarjoaja ei takaa, eikä 
			vastaa vahingoista, jotka koskevat Palvelun saatavuutta, käytettävyyttä, toimivuutta (esim. tietoliikenneyhteyksiä, yhteensopivuutta Palvelun 
			käyttäjien laitteistojen tai ohjelmistojen kanssa) taikka virheettömyyttä.
		</p>

		<p>
			Käyttäjän tulee noudattaa Palvelun käytössä ao. maan lakeja, hyviä tapoja ja mahdollisia lupakäytäntöjä. Käyttäjä käyttää Palvelua omalla 
			vastuullaan. Käyttäjän on käytettävä Palvelua siten, ettei Palvelulle, Palvelun tarjoajalle, yhteistyötahoille tai muille osapuolille aiheudu 
			haittaa käyttäjän toimista.
		</p>

		<h2 className='mt-4'>Palvelun tarjoajan oikeudet</h2>
		<p>
			Palvelua kehitetään jatkuvasti. Tämän vuoksi Palvelun tarjoajalla on oikeus muuttaa Palvelua ja myös näitä käyttöehtoja kehitystä vastaavalla 
			tavalla. Palvelun tarjoaja voi milloin tahansa muokata tai lopettaa Palvelun tai sen osan ilman erillistä ilmoitusta. Palvelun tarjoaja ei 
			ole tällöin vastuussa käyttäjälle aiheutuneista seurauksista.
		</p>
		<p>
			Palvelu perustuu Palvelun taustalla olevan Spiral-menetelmän toimivuudesta tehtyihin selvityksiin. Palvelun tarjoaja ei kuitenkaan voi taata 
			Palvelun yksittäistapauksellista toimivuutta.
		</p>
		<p>
			Palvelun tarjoaja ei vastaa käyttäjälle tai muulle osapuolelle Palvelun käytössä tai sen yhteydessä aiheutuneesta muusta välittömästä, 
			välillisestä, suorasta taikka epäsuorasta vahingosta.
		</p>
		<p>
			Palvelua tai Palvelusta saatavia tietoja ei saa käyttää muihin, kuin näissä käyttöehdoissa määriteltyihin tarkoitusperiin. Kysymykset ja 
			yhteydenotot Palvelun käytön suhteen voi lähettää osoitteeseen <a href='mailto:spiral@kuntoutussaatio.fi' target="_blank" rel='noopener noreferrer'>spiral@kuntoutussaatio.fi</a>.
		</p>
		<p>
			Palvelun tarjoaja: Kuntoutussäätiö (<a href='https://www.kuntoutussaatio.fi' target="_blank" rel='noopener noreferrer'>www.kuntoutussaatio.fi</a>)
		</p>
	</div>
)